export default __webpack_public_path__ + "static/media/PRIMARY-GHOST.48f6ffa7.svg";